"use client";
import useAgentData from "@casino/legacy/client/hooks/useAgentData";
import useIsRtl from "@casino/legacy/client/hooks/useIsRtl";
import {
  cn,
  Slider,
  SliderContent,
  SliderIndicators,
} from "@workspace/frontend-ui";
import CarouselButton from "./CarouselButton";
import CarouselItems from "./CarouselItems";
import getFullyVisibleScrollTarget from "./getFullyVisibleScrollTarget";

const DEFAULT_ITEMS_PER_ARROW_PRESS = 5;

type Props = {
  items?: React.ReactNode[];
  step?: number;
  scrollTo?: number;
  reelClassName?: string;
  scrollToLeftButton?: React.JSX.Element | null;
  scrollToRightButton?: React.JSX.Element | null;
  withIndicators?: boolean;
};

const Carousel = ({
  items,
  step,
  scrollTo,
  reelClassName,
  scrollToLeftButton = <CarouselButton direction="left" />,
  scrollToRightButton = <CarouselButton direction="right" />,
  withIndicators,
}: Props) => {
  const { isDesktop } = useAgentData();
  const { isRtl } = useIsRtl();

  return (
    <div className="min-w-0" data-testid="carousel-wrapper">
      <Slider
        dir={isRtl ? "rtl" : "ltr"}
        wheelBehavior="scroll-page"
        step={step ?? DEFAULT_ITEMS_PER_ARROW_PRESS}
        initialScrollToIndex={getFullyVisibleScrollTarget(
          scrollTo,
          items?.length ?? 0,
        )}
      >
        {scrollToLeftButton}
        <SliderContent
          bleed={isDesktop ? "none" : "gutter"}
          className={cn(
            "gap-3 rtl:flex-row-reverse",
            !isDesktop && "rtl:flex-row",
            reelClassName,
          )}
        >
          <CarouselItems items={items} />
        </SliderContent>
        {scrollToRightButton}
        {withIndicators && <SliderIndicators placement="below" />}
      </Slider>
    </div>
  );
};

export default Carousel;
